import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Home.css';

const weddingDate = new Date('2025-12-13T10:00:00');

function getTimeLeft() {
  const now = new Date();
  const timeLeft = weddingDate.getTime() - now.getTime();
  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  return { days, hours, minutes, seconds };
}

const Home: React.FC = () => {
  const [countdown, setCountdown] = useState(getTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const { days, hours, minutes, seconds } = countdown;

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="hero-text"
          >
            <h1 className="hero-title">
              Bruna & Lorhan
            </h1>
            <p className="hero-subtitle">
              Vão se casar!
            </p>
            <div className="hero-date">
              <Calendar className="icon" />
              <span>13 de Dezembro de 2025 as 11h00</span>
            </div>
            <div className="hero-location">
              <MapPin className="icon" />
              <span>Condomínio Ecogarden Residence, Maringá</span>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Countdown Section */}
      <section className="countdown-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="countdown-content"
          >
            <h2>Contagem regressiva para o nosso grande dia</h2>
            <div className="countdown-timer">
              <div className="countdown-item">
                <div className="countdown-number">{days}</div>
                <div className="countdown-label">Dias</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-number">{hours}</div>
                <div className="countdown-label">Horas</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-number">{minutes}</div>
                <div className="countdown-label">Minutos</div>
              </div>
              <div className="countdown-item">
                <div className="countdown-number">{seconds}</div>
                <div className="countdown-label">Segundos</div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Welcome Section */}
      <section className="welcome-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="welcome-content"
          >
            <Heart className="welcome-icon" />
            <h2>Sejam bem-vindos ao nosso grande dia!</h2>
            <p>
              Estamos muito felizes em celebrar nosso amor com a família e amigos. 
              Este site irá manter vocês atualizados com todas as informações sobre nosso grande dia.
            </p>
            <div className="welcome-buttons">
              <Link to="/wedding-details" className="btn btn-primary">Ver detalhes</Link>
              <Link to="/gallery" className="btn btn-secondary">Ver galeria</Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
